/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedThreadgate from './..\\feed\\threadgate.defs.js'
import * as FeedPostgate from './..\\feed\\postgate.defs.js'
import * as LabelDefs from './..\\..\\..\\com\\atproto\\label\\defs.defs.js'
import * as RepoStrongRef from './..\\..\\..\\com\\atproto\\repo\\strongRef.defs.js'

const $nsid = 'app.bsky.draft.defs'

type $nsid = typeof $nsid

export { $nsid }

/** A draft containing an array of draft posts. */
type Draft = {
  $type?: 'app.bsky.draft.defs#draft'

  /**
   * Indicates human language of posts primary text content.
   */
  langs?: l.LanguageString[]

  /**
   * Array of draft posts that compose this draft.
   */
  posts: DraftPost[]

  /**
   * UUIDv4 identifier of the device that created this draft.
   */
  deviceId?: string

  /**
   * The device and/or platform on which the draft was created.
   */
  deviceName?: string

  /**
   * Allow-rules for the threadgate to be created when this draft is published.
   */
  threadgateAllow?: (
    | l.$Typed<FeedThreadgate.MentionRule>
    | l.$Typed<FeedThreadgate.FollowerRule>
    | l.$Typed<FeedThreadgate.FollowingRule>
    | l.$Typed<FeedThreadgate.ListRule>
    | l.Unknown$TypedObject
  )[]

  /**
   * Embedding rules for the postgates to be created when this draft is published.
   */
  postgateEmbeddingRules?: (
    l.$Typed<FeedPostgate.DisableRule> | l.Unknown$TypedObject
  )[]
}

export type { Draft }

/** A draft containing an array of draft posts. */
const draft = /*#__PURE__*/ l.typedObject<Draft>(
  $nsid,
  'draft',
  /*#__PURE__*/ l.object({
    langs: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'language' }), {
        maxLength: 3,
      }),
    ),
    posts: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<DraftPost>((() => draftPost) as any),
      { maxLength: 100, minLength: 1 },
    ),
    deviceId: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 100 }),
    ),
    deviceName: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 100 }),
    ),
    threadgateAllow: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.typedUnion(
          [
            /*#__PURE__*/ l.typedRef<FeedThreadgate.MentionRule>(
              (() => FeedThreadgate.mentionRule) as any,
            ),
            /*#__PURE__*/ l.typedRef<FeedThreadgate.FollowerRule>(
              (() => FeedThreadgate.followerRule) as any,
            ),
            /*#__PURE__*/ l.typedRef<FeedThreadgate.FollowingRule>(
              (() => FeedThreadgate.followingRule) as any,
            ),
            /*#__PURE__*/ l.typedRef<FeedThreadgate.ListRule>(
              (() => FeedThreadgate.listRule) as any,
            ),
          ],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
    postgateEmbeddingRules: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.typedUnion(
          [
            /*#__PURE__*/ l.typedRef<FeedPostgate.DisableRule>(
              (() => FeedPostgate.disableRule) as any,
            ),
          ],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
  }),
)

export { draft }

/** One of the posts that compose a draft. */
type DraftPost = {
  $type?: 'app.bsky.draft.defs#draftPost'

  /**
   * The primary post content. It has a higher limit than post contents to allow storing a larger text that can later be refined into smaller posts.
   */
  text: string

  /**
   * Self-label values for this post. Effectively content warnings.
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  embedImages?: DraftEmbedImage[]
  embedVideos?: DraftEmbedVideo[]
  embedGallery?: DraftEmbedGallery
  embedRecords?: DraftEmbedRecord[]
  embedExternals?: DraftEmbedExternal[]
}

export type { DraftPost }

/** One of the posts that compose a draft. */
const draftPost = /*#__PURE__*/ l.typedObject<DraftPost>(
  $nsid,
  'draftPost',
  /*#__PURE__*/ l.object({
    text: /*#__PURE__*/ l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<LabelDefs.SelfLabels>(
            (() => LabelDefs.selfLabels) as any,
          ),
        ],
        false,
      ),
    ),
    embedImages: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<DraftEmbedImage>((() => draftEmbedImage) as any),
        { maxLength: 4 },
      ),
    ),
    embedVideos: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<DraftEmbedVideo>((() => draftEmbedVideo) as any),
        { maxLength: 1 },
      ),
    ),
    embedGallery: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<DraftEmbedGallery>((() => draftEmbedGallery) as any),
    ),
    embedRecords: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<DraftEmbedRecord>((() => draftEmbedRecord) as any),
        { maxLength: 1 },
      ),
    ),
    embedExternals: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<DraftEmbedExternal>(
          (() => draftEmbedExternal) as any,
        ),
        { maxLength: 1 },
      ),
    ),
  }),
)

export { draftPost }

/** View to present drafts data to users. */
type DraftView = {
  $type?: 'app.bsky.draft.defs#draftView'

  /**
   * A TID to be used as a draft identifier.
   */
  id: l.TidString
  draft: Draft

  /**
   * The time the draft was created.
   */
  createdAt: l.DatetimeString

  /**
   * The time the draft was last updated.
   */
  updatedAt: l.DatetimeString
}

export type { DraftView }

/** View to present drafts data to users. */
const draftView = /*#__PURE__*/ l.typedObject<DraftView>(
  $nsid,
  'draftView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string({ format: 'tid' }),
    draft: /*#__PURE__*/ l.ref<Draft>((() => draft) as any),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { draftView }

/** A draft with an identifier, used to store drafts in private storage (stash). */
type DraftWithId = {
  $type?: 'app.bsky.draft.defs#draftWithId'

  /**
   * A TID to be used as a draft identifier.
   */
  id: l.TidString
  draft: Draft
}

export type { DraftWithId }

/** A draft with an identifier, used to store drafts in private storage (stash). */
const draftWithId = /*#__PURE__*/ l.typedObject<DraftWithId>(
  $nsid,
  'draftWithId',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string({ format: 'tid' }),
    draft: /*#__PURE__*/ l.ref<Draft>((() => draft) as any),
  }),
)

export { draftWithId }

type DraftEmbedImage = {
  $type?: 'app.bsky.draft.defs#draftEmbedImage'
  alt?: string
  localRef: DraftEmbedLocalRef
}

export type { DraftEmbedImage }

const draftEmbedImage = /*#__PURE__*/ l.typedObject<DraftEmbedImage>(
  $nsid,
  'draftEmbedImage',
  /*#__PURE__*/ l.object({
    alt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 2000 }),
    ),
    localRef: /*#__PURE__*/ l.ref<DraftEmbedLocalRef>(
      (() => draftEmbedLocalRef) as any,
    ),
  }),
)

export { draftEmbedImage }

type DraftEmbedVideo = {
  $type?: 'app.bsky.draft.defs#draftEmbedVideo'
  alt?: string
  captions?: DraftEmbedCaption[]
  localRef: DraftEmbedLocalRef
}

export type { DraftEmbedVideo }

const draftEmbedVideo = /*#__PURE__*/ l.typedObject<DraftEmbedVideo>(
  $nsid,
  'draftEmbedVideo',
  /*#__PURE__*/ l.object({
    alt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 2000 }),
    ),
    captions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<DraftEmbedCaption>(
          (() => draftEmbedCaption) as any,
        ),
        { maxLength: 20 },
      ),
    ),
    localRef: /*#__PURE__*/ l.ref<DraftEmbedLocalRef>(
      (() => draftEmbedLocalRef) as any,
    ),
  }),
)

export { draftEmbedVideo }

type DraftEmbedRecord = {
  $type?: 'app.bsky.draft.defs#draftEmbedRecord'
  record: RepoStrongRef.Main
}

export type { DraftEmbedRecord }

const draftEmbedRecord = /*#__PURE__*/ l.typedObject<DraftEmbedRecord>(
  $nsid,
  'draftEmbedRecord',
  /*#__PURE__*/ l.object({
    record: /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
      (() => RepoStrongRef.main) as any,
    ),
  }),
)

export { draftEmbedRecord }

type DraftEmbedCaption = {
  $type?: 'app.bsky.draft.defs#draftEmbedCaption'
  lang: l.LanguageString
  content: string
}

export type { DraftEmbedCaption }

const draftEmbedCaption = /*#__PURE__*/ l.typedObject<DraftEmbedCaption>(
  $nsid,
  'draftEmbedCaption',
  /*#__PURE__*/ l.object({
    lang: /*#__PURE__*/ l.string({ format: 'language' }),
    content: /*#__PURE__*/ l.string({ maxLength: 10000 }),
  }),
)

export { draftEmbedCaption }

type DraftEmbedGallery = {
  $type?: 'app.bsky.draft.defs#draftEmbedGallery'
  items: DraftEmbedGalleryItems
}

export type { DraftEmbedGallery }

const draftEmbedGallery = /*#__PURE__*/ l.typedObject<DraftEmbedGallery>(
  $nsid,
  'draftEmbedGallery',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.ref<DraftEmbedGalleryItems>(
      (() => draftEmbedGalleryItems) as any,
    ),
  }),
)

export { draftEmbedGallery }

type DraftEmbedExternal = {
  $type?: 'app.bsky.draft.defs#draftEmbedExternal'
  uri: l.UriString
}

export type { DraftEmbedExternal }

const draftEmbedExternal = /*#__PURE__*/ l.typedObject<DraftEmbedExternal>(
  $nsid,
  'draftEmbedExternal',
  /*#__PURE__*/ l.object({ uri: /*#__PURE__*/ l.string({ format: 'uri' }) }),
)

export { draftEmbedExternal }

type DraftEmbedLocalRef = {
  $type?: 'app.bsky.draft.defs#draftEmbedLocalRef'

  /**
   * Local, on-device ref to file to be embedded. Embeds are currently device-bound for drafts.
   */
  path: string
}

export type { DraftEmbedLocalRef }

const draftEmbedLocalRef = /*#__PURE__*/ l.typedObject<DraftEmbedLocalRef>(
  $nsid,
  'draftEmbedLocalRef',
  /*#__PURE__*/ l.object({
    path: /*#__PURE__*/ l.string({ maxLength: 1024, minLength: 1 }),
  }),
)

export { draftEmbedLocalRef }

/** The schema-level maxLength of 20 is a future-proof ceiling. Clients should currently enforce a soft limit of 10 items in authoring UIs. */
type DraftEmbedGalleryItems = (
  l.$Typed<DraftEmbedImage> | l.Unknown$TypedObject
)[]

export type { DraftEmbedGalleryItems }

/** The schema-level maxLength of 20 is a future-proof ceiling. Clients should currently enforce a soft limit of 10 items in authoring UIs. */
const draftEmbedGalleryItems = /*#__PURE__*/ l.array<
  DraftEmbedGalleryItems[number]
>(
  /*#__PURE__*/ l.typedUnion(
    [/*#__PURE__*/ l.typedRef<DraftEmbedImage>((() => draftEmbedImage) as any)],
    false,
  ),
  { maxLength: 20 },
)

export { draftEmbedGalleryItems }
